<template lang="pug">
b-table.kpi-drilldown-table(
  :items="items"
  :fields="fields"
  striped
  hover
  small
  responsive
  show-empty
  empty-text="Sin elementos"
)
  template(#cell(ariStatus)="data")
    b-badge(:variant="data.item.ariStatus === 'Sí' ? 'light-success' : 'light-danger'")
      | {{ data.item.ariStatus }}

  template(#cell(level)="data")
    risk-level-badge(:level="data.item.level || ''")

  template(#cell(status)="data")
    gap-status-badge(:status="data.item.status || 'No implementado'")

  template(#cell(planStatus)="data")
    b-badge(
      v-if="data.item.planStatus && data.item.planStatus !== '-'"
      :variant="getPlanStatusVariant(data.item.planStatus)"
    )
      | {{ data.item.planStatus }}

  template(#cell(deadline)="data")
    span(v-if="data.item.deadline && data.item.deadline !== '-'" :class="getDeadlineClass(data.item.deadline)")
      | {{ formatDate(data.item.deadline) }}
    span(v-else) -

  template(#cell(actions)="data")
    b-button(
      v-if="canEditItem"
      variant="flat-primary"
      size="sm"
      @click="goToItem(data.item)"
    )
      feather-icon(icon="ExternalLinkIcon")
</template>

<script>
import { computed } from '@vue/composition-api'
import { BTable, BBadge, BButton } from 'bootstrap-vue'
import { useRouter } from '@core/utils/utils'
import { hasPermission } from '@/composables/usePermission'
import RiskLevelBadge from './RiskLevelBadge.vue'
import GapStatusBadge from './GapStatusBadge.vue'

export default {
  name: 'KpiDrilldownTable',
  components: { BTable, BBadge, BButton, RiskLevelBadge, GapStatusBadge },
  props: {
    items: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
  },
  setup() {
    const { router } = useRouter()

    const canEditItem = computed(() => hasPermission('privacy-indicators', 'edit'))

    const getPlanStatusVariant = (status) => {
      const map = {
        Pendiente: 'warning',
        'En progreso': 'info',
        Cerrado: 'success',
      }
      return map[status] || 'secondary'
    }

    const formatDate = (date) => {
      if (!date) return '-'
      const d = new Date(date)
      const year = d.getUTCFullYear()
      const month = String(d.getUTCMonth() + 1).padStart(2, '0')
      const day = String(d.getUTCDate()).padStart(2, '0')
      return `${day}-${month}-${year}`
    }

    const getDeadlineClass = (deadline) => {
      if (!deadline) return ''
      const today = new Date()
      const deadlineDate = new Date(deadline)
      const daysUntilDeadline = Math.floor((deadlineDate - today) / (1000 * 60 * 60 * 24))
      if (daysUntilDeadline < 0) return 'text-danger font-weight-bold'
      if (daysUntilDeadline <= 7) return 'text-warning font-weight-bold'
      return ''
    }

    const goToItem = (item) => {
      if (item.route && item._id) {
        const resolved = router.resolve({ name: item.route, params: { id: item._id } })
        window.open(resolved.href, '_blank')
      }
    }

    return { getPlanStatusVariant, formatDate, getDeadlineClass, goToItem, canEditItem }
  },
}
</script>

<style lang="scss" scoped>
.kpi-drilldown-table {
  margin-bottom: 0;
  font-size: 0.8rem;

  ::v-deep {
    thead th {
      font-size: 0.7rem;
      font-weight: 600;
    }

    .badge {
      font-size: 0.7rem !important;
      padding: 0.25rem 0.5rem !important;
      min-width: auto !important;
    }

    .risk-level-badge {
      font-size: 0.7rem !important;
      padding: 0.25rem 0.5rem !important;
    }
  }
}
</style>
